import React from 'react'
import { PurchaseOrder, PurchaseOrderStatus } from './types'
import OrderCard from './OrderCard'
import StatusActionsMenu from './StatusActionsMenu'
import { BoardGrid, EmptyState } from './style'

interface BoardViewProps {
  orders: PurchaseOrder[]
  onStatusChange: (orderId: number, status: PurchaseOrderStatus) => Promise<void>
}

const BoardView: React.FC<BoardViewProps> = ({ orders, onStatusChange }) => {
  if (!orders.length) return <EmptyState>Nenhuma ordem de compra encontrada.</EmptyState>

  return (
    <BoardGrid>
      {orders.map((order) => (
        <OrderCard
          key={order.id}
          order={order}
          actions={<StatusActionsMenu order={order} onStatusChange={onStatusChange} />}
        />
      ))}
    </BoardGrid>
  )
}

export default BoardView
